<div class="container m-b-20 layout-row align-end gap-20px">
  <button mat-raised-button color="primary" [routerLink]="['edit']" *LOSxHasPermission="'UPDATE_HOOK'">
    <fa-icon icon="edit" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Edit' | translate }}
  </button>

  <button mat-raised-button color="warn" (click)="delete()" *LOSxHasPermission="'DELETE_HOOK'">
    <fa-icon icon="trash" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Delete' | translate }}
  </button>
</div>

<div class="container">
  <mat-card>
    <mat-card-content>
      <div class="layout-row-wrap">
        <div class="flex-50 mat-body-strong">{{ 'labels.inputs.Hook Name' | translate }}:</div>

        <div class="flex-50">
          {{ hookData.displayName }}
        </div>

        <div class="flex-50 mat-body-strong">{{ 'labels.inputs.Status' | translate }}:</div>

        <div class="flex-50">
          {{ hookData.isActive ? ('labels.inputs.Active' | translate) : ('labels.catalogs.Inactive' | translate) }}
        </div>

        <div class="flex-50 mat-body-strong">{{ 'labels.inputs.Activation Date' | translate }}:</div>

        <div class="flex-50">
          {{ hookData.createdAt | dateFormat }}
        </div>

        <div class="flex-50 mat-body-strong">{{ 'labels.inputs.Updated on' | translate }}:</div>

        <div class="flex-50">
          {{ hookData.updatedAt | dateFormat }}
        </div>

        <div class="flex-50 mat-body-strong">{{ 'labels.inputs.Events' | translate }}:</div>

        <div class="flex-50">
          @for (event of hookData.events; track event) {
            <mat-label>
              {{ event.actionName + '  -  ' + event.entityName }}
              <br />
            </mat-label>
          }
        </div>

        @if (hookData.name === 'Web') {
          <div class="flex-50 mat-body-strong">{{ 'labels.inputs.Content Type' | translate }}:</div>
        }

        @if (hookData.name === 'Web') {
          <div class="flex-50">
            {{ hookData.config[0].fieldValue }}
          </div>
        }

        <div class="flex-50 mat-body-strong">{{ 'labels.inputs.Payload URL' | translate }}:</div>

        @if (hookData.name === 'Web') {
          <div class="flex-50">
            {{ hookData.config[1].fieldValue }}
          </div>
        }

        @if (hookData.name === 'SMS Bridge') {
          <div class="flex-50">
            {{ hookData.config[0].fieldValue }}
          </div>
        }

        @if (hookData.name === 'SMS Bridge') {
          <div class="flex-50 mat-body-strong">{{ 'labels.inputs.Phone Number' | translate }}:</div>
        }

        @if (hookData.name === 'SMS Bridge') {
          <div class="flex-50">
            {{ hookData.config[1].fieldValue }}
          </div>
        }

        @if (hookData.name === 'SMS Bridge') {
          <div class="flex-50 mat-body-strong">{{ 'labels.inputs.SMS Provider' | translate }}:</div>
        }

        @if (hookData.name === 'SMS Bridge') {
          <div class="flex-50">
            {{ hookData.config[2].fieldValue }}
          </div>
        }

        @if (hookData.name === 'SMS Bridge') {
          <div class="flex-50 mat-body-strong">{{ 'labels.inputs.SMS Provider Account ID' | translate }}:</div>
        }

        @if (hookData.name === 'SMS Bridge') {
          <div class="flex-50">
            {{ hookData.config[3].fieldValue }}
          </div>
        }

        @if (hookData.name === 'SMS Bridge') {
          <div class="flex-50 mat-body-strong">{{ 'labels.inputs.SMS Provider Token' | translate }}:</div>
        }

        @if (hookData.name === 'SMS Bridge') {
          <div class="flex-50">
            {{ hookData.config[4].fieldValue }}
          </div>
        }
      </div>
    </mat-card-content>
  </mat-card>
</div>
